import { useMemo } from 'react'

import { useGetFilterValue } from '@/legacy-src/components/filters/hooks/useGetFilterValue'
import { useSetFilters } from '@/legacy-src/components/filters/hooks/useSetFilters'
import useServices from '@/legacy-src/hooks/useServices'

import { parseTherapistSessionLocationFilterValue } from '@/src/domains/therapist-filters/utils/parseTherapistSessionLocationFilterValue'

export const useTherapistSessionLocationFilter = () => {
  const { selectedServiceId } = useServices()

  const filterSessionLocationValue = useGetFilterValue('sessionLocation')

  const location = useMemo(
    () => parseTherapistSessionLocationFilterValue(filterSessionLocationValue),
    [filterSessionLocationValue],
  )

  const setFilters = useSetFilters()

  const handleLocationFilter = (value: number[]) =>
    setFilters([
      {
        slug: 'sessionLocation',
        value: value.map((item) => item.toString()),
      },
    ])

  return {
    serviceId: selectedServiceId,
    location,
    handleLocationFilter,
  }
}
